import React from 'react';

import { LogoutModal } from '@/features/personalAccount/views/LogoutModal';
import { Icon } from '@/ui/Icon';
import { useTranslation } from 'react-i18next';

const LogoutButton = () => {
	const { t } = useTranslation();

	return (
		<div className="p-4">
			<LogoutModal
				trigger={
					<button
						data-testid="main-button-logout"
						className="size-[calc(24px*var(--font-scale,1))]"
						type="button"
						aria-label={t('accessibility.logoutButton.label')}
					>
						<Icon
							name="logout"
							className="size-[calc(24px*var(--font-scale,1))] text-gray-400 cursor-pointer"
							size={24}
							aria-hidden="true"
						/>
					</button>
				}
			/>
		</div>
	);
};

export { LogoutButton };
